import { render, staticRenderFns } from "./MyRebates.vue?vue&type=template&id=bbb225d0&scoped=true"
import script from "./MyRebates.vue?vue&type=script&lang=js"
export * from "./MyRebates.vue?vue&type=script&lang=js"
import style0 from "./MyRebates.vue?vue&type=style&index=0&id=bbb225d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb225d0",
  null
  
)

export default component.exports